<template>
  <div>
    <base-table :loading="isLoading" :fields="fields" :items="invoices" class="tw-mt-5">
      <template #date="{item: invoice}">
        <div>{{ formatDate(invoice.created) }}</div>
      </template>
      <template #invoiceNumber="{item: invoice}">
        <div>{{ invoice.number }}</div>
      </template>
      <template #total="{item: invoice}">
        <MoneyFormat :value="invoice.total" :locale="locale" :currency-code="invoice.currency" subunits-value />
      </template>
      <template #status="{item: invoice}">
        <div>{{ capitalize(invoice.status) }}</div>
      </template>
      <template #actions="{item: invoice}">
        <div class="tw-flex tw-justify-center tw-space-x-2">
          <a :href="invoice.pdf">
            <base-button type="flat"
              ><template v-slot:icon>
                <download-icon /> </template
              >Download</base-button
            ></a
          >
        </div>
      </template>
      <template #empty-state>
        <div class="tw-flex tw-justify-center tw-py-5">
          No Results
        </div>
      </template>
      <template #loading-row>
        <td class="tw-py-3 tw-px-4">
          <base-skeleton-loader class="tw-h-4 tw-w-16" />
        </td>
        <td class="tw-py-3 tw-px-4">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
        </td>
        <td class="tw-py-3 tw-px-4">
          <base-skeleton-loader class="tw-h-4 tw-w-16" />
        </td>
        <td class="tw-py-3 tw-px-4">
          <base-skeleton-loader class="tw-h-4 tw-w-16" />
        </td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-justify-center tw-space-x-2">
            <base-skeleton-loader class="tw-h-6 tw-w-12" />
          </div>
        </td>
      </template>
    </base-table>
    <base-pagination v-model="page" class="tw-mt-2" />
  </div>
</template>
<script>
import moment from "moment";
import MoneyFormat from "vue-money-format";
import { capitalize } from "lodash";
import { DownloadIcon } from "@/assets/svgs";

const TAKE_KEY = "predictile_subscription_hist_take";

export default {
  name: "PaymentHistory",
  components: {
    MoneyFormat,
    DownloadIcon,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      invoices: [],
      isLoading: false,
      page: {
        take: localStorage.getItem(TAKE_KEY) ? +localStorage.getItem(TAKE_KEY) : 50,
        skip: 0,
        total: 0,
      },
      fields: [
        { title: "Date", key: "date", thClass: "" },
        { title: "Invoice #", key: "invoiceNumber", thClass: "" },
        { title: "Total", key: "total", thClass: "" },
        { title: "Status", key: "status", thClass: "tw-w-0" },
        { title: "Actions", key: "actions", thClass: "tw-text-center" },
      ],
    };
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    capitalize,
    loadPage() {
      this.isLoading = true;
      this.$axios
        .get(`/businesses/${this.businessId}/subscription/invoices`)
        .then((res) => {
          this.invoices = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Payment History Failed",
            message: "Sorry, It looks like we had some trouble loading your payment history. You may want to try again.",
            error: err,
          });
        });
    },
    formatDate(date) {
      return new moment.utc(date).local().format("M/D/YYYY");
    },
  },
};
</script>
